import sha256 from 'crypto-js/sha256';
import Base64 from 'crypto-js/enc-base64';
import hmacSHA256 from 'crypto-js/hmac-sha256';
import { createServerTime } from './serverTime.js';

const hmac = (config, { secret, username, apiKey }) => {
    const { data = '', url, baseURL = '', method } = config;
    const body_digest = `SHA-256=${Base64.stringify(sha256(data))}`;
    const uri = baseURL + url;
    const date = createServerTime().time.toUTCString();
    const sign = `x-date: ${date}\n${method?.toUpperCase()} ${uri} HTTP/1.1`;
    const base64_digest = Base64.stringify(hmacSHA256(sign, secret));
    const authorization = `hmac username="${username}", algorithm="hmac-sha256", headers="x-date request-line", signature="${base64_digest}"`;
    return {
        'X-Date': date,
        Digest: body_digest,
        Authorization: authorization,
        apiKey,
    };
};
const getHmacHeaders = ({ url, baseURL, data = '', method = 'get', secret, username, apiKey, }) => {
    if (!secret)
        return {};
    return hmac({
        data,
        url,
        baseURL,
        method,
    }, {
        secret,
        username,
        apiKey,
    });
};

export { getHmacHeaders, hmac };
